import { formatApiErrorMessage } from '@/api/http';

function dedupeRepeatedPhrase(msg: string): string {
  const t = msg.trim();
  if (!t) return t;
  const lower = t.toLowerCase();
  const half = Math.floor(t.length / 2);
  for (let i = Math.max(1, half - 2); i <= half + 2 && i < t.length; i += 1) {
    const head = t.slice(0, i).trim();
    const tail = t.slice(i).trim();
    if (head && tail && head.toLowerCase() === tail.toLowerCase()) {
      return head;
    }
  }
  if (lower.includes('network error') && lower.replace(/network error/gi, '').trim() === 'network error') {
    return 'Network Error';
  }
  return t;
}

/** fetch/SSE 在休眠、断网、代理中断时的典型错误 */
export function isTemplateGenerationNetworkError(err: unknown, message?: string): boolean {
  const msg = (message || formatApiErrorMessage(err)).trim().toLowerCase();
  if (!msg) return false;
  return (
    msg.includes('network error')
    || msg.includes('failed to fetch')
    || msg.includes('networkerror')
    || msg.includes('load failed')
    || msg.includes('the internet connection appears to be offline')
    || msg.includes('err_network')
    || msg.includes('流式响应未正常结束')
  );
}

export function formatTemplateGenerationError(err: unknown): string {
  const raw = dedupeRepeatedPhrase(formatApiErrorMessage(err));
  if (isTemplateGenerationNetworkError(err, raw)) {
    return '网络连接已中断（可能因电脑休眠或断网）。请点击消息上的「重试」继续生成，无需重新选择模版。';
  }
  return raw;
}
